import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className='service'>
      <h3>Customer Service</h3>
      <p>Main No: 123-111-111</p>
      <p>Loan Inquiries: 123-111-112</p>
      <p>Credit Inquiries: 123-111-113</p>
      <p> Account Inquiries: 123-111-114</p>
    </div>
  );
};

export default Contact;
